"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _pclnDesignSystem = require("pcln-design-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CarouselContainer = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "sc-1k4rd5-0"
})(["align-items:center;"]);
var ContentWrapper = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "sc-1k4rd5-1"
})(["overflow:hidden;"]);
var Content = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "sc-1k4rd5-2"
})(["transition:transform ease 0.45s;transform:", ";"], function (props) {
  return props.transform;
});
var Arrow = (0, _styledComponents["default"])(_pclnDesignSystem.IconButton).withConfig({
  componentId: "sc-1k4rd5-3"
})(["size:50;z-index:2;margin:8px;color:", ";background-color:", ";&:hover{color:", ";background-color:", ";}&:focus{outline:none;}"], function (props) {
  return props.disabled ? (0, _pclnDesignSystem.getPaletteColor)('text.light')(props) : (0, _pclnDesignSystem.getPaletteColor)('text.lightest')(props);
}, function (props) {
  return props.disabled ? (0, _pclnDesignSystem.getPaletteColor)('background.base')(props) : (0, _pclnDesignSystem.getPaletteColor)('primary.base')(props);
}, function (props) {
  return props.disabled ? (0, _pclnDesignSystem.getPaletteColor)('text.light')(props) : (0, _pclnDesignSystem.getPaletteColor)('text.lightest')(props);
}, function (props) {
  return props.disabled ? (0, _pclnDesignSystem.getPaletteColor)('background.base')(props) : (0, _pclnDesignSystem.getPaletteColor)('primary.dark')(props);
});

function Carousel(_ref) {
  var className = _ref.className,
      children = _ref.children,
      width = _ref.width,
      imageWidth = _ref.imageWidth,
      onChange = _ref.onChange;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      currentIndex = _useState2[0],
      setIndex = _useState2[1];

  var xOffset = -currentIndex * imageWidth;
  var imageCount = children.length < width ? children.length : width;
  var carouselWidth = imageCount * imageWidth;
  var isFirstImage = currentIndex === 0;
  var isLastImage = currentIndex === children.length - imageCount;

  var nextItem = function nextItem() {
    setIndex(currentIndex + 1);
    onChange();
  };

  var previousItem = function previousItem() {
    setIndex(currentIndex - 1);
    onChange();
  };

  return imageCount > 0 && _react["default"].createElement(CarouselContainer, {
    className: className
  }, _react["default"].createElement(Arrow, {
    disabled: isFirstImage,
    name: "chevronLeft",
    title: "Show previous item",
    onClick: previousItem
  }), _react["default"].createElement(ContentWrapper, {
    width: carouselWidth
  }, _react["default"].createElement(Content, {
    transform: "translateX(".concat(xOffset, "px)")
  }, children)), _react["default"].createElement(Arrow, {
    disabled: isLastImage,
    name: "chevronRight",
    title: "Show next item",
    onClick: nextItem
  }));
}

Carousel.displayName = 'Carousel';
Carousel.propTypes = {
  className: _propTypes["default"].string,
  width: _propTypes["default"].number,
  imageWidth: _propTypes["default"].number,
  children: _propTypes["default"].node,
  onChange: _propTypes["default"].func
};
Carousel.defaultProps = {
  className: '',
  width: 2,
  imageWidth: 200,
  onChange: function onChange() {
    return null;
  }
};

var _default = (0, _react.memo)(Carousel);

exports["default"] = _default;